"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  BORDER_RADIUS: true,
  FONT: true,
  BORDER: true
};
Object.defineProperty(exports, "BORDER", {
  enumerable: true,
  get: function () {
    return _border.BORDER;
  }
});
exports.BORDER_RADIUS = void 0;
Object.defineProperty(exports, "FONT", {
  enumerable: true,
  get: function () {
    return _font.FONT;
  }
});
var _color = require("./color");
Object.keys(_color).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _color[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _color[key];
    }
  });
});
var _font = require("./font");
var _border = require("./border");
var _layout = require("./layout");
Object.keys(_layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _layout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _layout[key];
    }
  });
});
var _interactive = require("./interactive");
Object.keys(_interactive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _interactive[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _interactive[key];
    }
  });
});
// todo: deprecate in next major release

const BORDER_RADIUS = exports.BORDER_RADIUS = _border.RADIUS;